// extracted by mini-css-extract-plugin
export default {"powers-explanation__logo":"powers-explanation__logo--3RyW4","powers-explanation__logo__icon":"powers-explanation__logo__icon--3zyQs","powers-explanation__container":"powers-explanation__container--1ECu3","powers-explanation__button-container":"powers-explanation__button-container--2IQD3","powers-explanation__button-container__button":"powers-explanation__button-container__button--22Yz0"};
    if(module.hot) {
      // 1747648148985
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  